module.exports = __webpack_public_path__ + "static/media/m_w_hw_0.e9f851f7.png";